export default __webpack_public_path__ + "static/media/2453.ad69c749.png";